export const TYPE_CONDITIONAL_LOGIC = 'conditional_logic'
export const TYPE_VALIDATION = 'validation'
